export default "__VITE_ASSET__CLO9DBER__"